import React from 'react'
import css from './style.scss'
import cn from 'classnames'
import moment from 'moment'
import {StatTitle} from './utils'

function getDates(stories, startDate, stopDate) {
    let currentDate = moment(startDate).startOf("day");
    stopDate = moment(stopDate).startOf("day");
    let monthArray = []
    let days = {totalDays:0, postedDays:0}
    let currentMonth = { name: currentDate.format("MMMM"), days: []}
    monthArray.push(currentMonth)
    while (currentDate <= stopDate) {
        let thisDate = moment(currentDate).startOf("day")
        currentDate = moment(currentDate).add(1, 'days').startOf("day");
        days.totalDays = days.totalDays + 1;
        let st=stories.filter(s=> moment(s.posted_at).isSame(thisDate, "day"))
        if(currentDate.date()===1){
          currentMonth = { name: currentDate.format("MMMM"), days: [] }
          monthArray.push(currentMonth)
        }
        if(st.length>0){days.postedDays=days.postedDays+1}
        currentMonth.days.push({ day: thisDate, count: st.length })
    }
    return {months: monthArray, days: days};
}
const StreakMonth = ({name, days}) => (
  <div className={css.streak_month}>
    <div className={css.streak_month_name}>{name}</div>
    <div className={css.streak_month_days}>{days.map(d => <StreakDate key={d.day.format("DD-MM")} date={d} />)}</div>
  </div>

)
const StreakDate=(props)=>(
  <div title={"You created "+props.date.count+ " Stories this day"} className={cn(css.streak_date, props.date.count>0 ? css.selected : "")}>
    {props.date.day.format("DD")}
  </div>
)

class StreakSection extends React.Component{
  constructor(props){
    super(props)
    this.state={
      months:[],
      days: { totalDays: 0, postedDays: 0 }
    }
  }
  componentDidMount(){
    this.loadStats(this.props)
  }

  componentWillReceiveProps(props){
    this.loadStats(props)
  }

  loadStats=(props)=>{
    this.setState(getDates(props.stories, props.startDate.toDate(), props.endDate.toDate()))
  }
  render(){
    return (
      <div className={cn(this.props.className, css.statsBox)}>
        <StatTitle>Streak</StatTitle>
        <div>
          <p>You posted on <b>{this.state.days.postedDays}</b> of <b>{this.state.days.totalDays}</b> days.</p>
          <div className={css.streakContainer}>
            {this.state.months.map(m=>(<StreakMonth name={m.name} days={m.days} key={m.name}/>))}
          </div>
        </div>

      </div>
    )
  }
}

export default StreakSection;



// WEBPACK FOOTER //
// ./src/components/account_page/stats/sections/streak.js